import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WCBAllProvincesRemittanceSetup } from "../../components/WCBAllProvincesRemittanceSetup";
import { useParams } from "react-router-dom";

export const WCBAllProvincesRemittanceSetupPage = () => {
  const { wcbProvinceName } = useParams();
  return (
    <AuthenticatedLayout
      pageTitle={`${
        // wcbProvinceName === "federal" ? "Federal" :
        wcbProvinceName === "alberta" ? "Alberta" :
          wcbProvinceName === "british_columbia" ? "British Columbia" :
            wcbProvinceName === "manitoba" ? "Manitoba" :
              wcbProvinceName === "new_brunswick" ? "New Brunswick" :
                wcbProvinceName === "newfoundland_and_labrador" ? "Newfoundland and Labrador" :
                  wcbProvinceName === "northwest_territories" ? "Northwest Territories" :
                    wcbProvinceName === "nova_scotia" ? "Nova Scotia" :
                      wcbProvinceName === "nunavut" ? "Nunavut" :
                        wcbProvinceName === "ontario" ? "Ontario" :
                          wcbProvinceName === "prince_edward_island" ? "Prince Edward Island" :
                            wcbProvinceName === "quebec" ? "Quebec" :
                              wcbProvinceName === "saskatchewan" ? "Saskatchewan" :
                                wcbProvinceName === "yukon" ? "Yukon" :
                                  wcbProvinceName
        }`}

      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<WCBAllProvincesRemittanceSetup />}
    />
  );
};
